<template>
  <div class="cookie-consent fixed bottom-0 w-full bg-white z-20" :class="{open: open}">
    <div class="inner flex items-center justify-between">
      <p class="m-4">
        This site uses Google Analytics. By continuing, you accept the use of cookies.
        <router-link to="/privacy"></router-link>
      </p>
      <div class="ok-btn h-full flex justify-center items-center cursor-pointer" @click="accept">
        OK
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',

  data () {
    return {
      open: false,
      storageKey: 'eer-cookie-consent',
      responded: null,
      accepted: null
    }
  },

  mounted () {
    if (!localStorage.getItem(this.storageKey)) {
      this.open = true
    }
  },

  methods: {
    accept () {
      this.$ga.enable()
      this.open = false
      localStorage.setItem(this.storageKey, 'true')
    }
  }
}
</script>

<style scoped>
.cookie-consent {
  height: 0;
  overflow: hidden;
  transition: height .25s ease-in-out;
}

.cookie-consent.open {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  height: 64px;
}

.cookie-consent .inner {
  height: 64px;
}

.ok-btn {
  border-left: 1px solid black;
  width: 16.6666%;
}

</style>